// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 191) return "/dist/js/header.js";
	if (chunkId === 803) return "/dist/js/menu-mobile.js";
	if (chunkId === 585) return "/dist/js/popup.js";
	if (chunkId === 4) return "/dist/js/slider.js";
	if (chunkId === 819) return "/dist/js/accordion.js";
	if (chunkId === 666) return "/dist/js/loader.js";
	if (chunkId === 757) return "/dist/js/form-contact.js";
	if (chunkId === 789) return "/dist/js/carousel-testimonials.js";
	if (chunkId === 699) return "/dist/js/carousel-featured-listings.js";
	if (chunkId === 205) return "/dist/js/google-map.js";
	if (chunkId === 164) return "/dist/js/gallery.js";
	if (chunkId === 658) return "/dist/js/list-advantages.js";
	// return url for filenames based on template
	return undefined;
};